var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserFill = function SvgUserFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.6v21.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.689 5.814a2.898 2.898 0 0 1-1.8 2.7 2.997 2.997 0 0 1-1.683.162 2.907 2.907 0 0 1-1.044-5.274 2.97 2.97 0 0 1 1.638-.495c.77 0 1.509.309 2.052.855.279.267.5.589.648.945.134.353.198.73.189 1.107zM17.874 18.099c-.153.188-.347.34-.567.441-.22.1-.46.153-.702.153H4.977a1.62 1.62 0 0 1-1.269-.594 1.476 1.476 0 0 1-.297-.594 1.656 1.656 0 0 1 0-.666 7.569 7.569 0 0 1 14.832 0c.05.222.05.453 0 .675a1.467 1.467 0 0 1-.369.585z",
    fill: "#C2C6D5",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-fill.48a066ae.svg";
export { ForwardRef as ReactComponent };